import React from 'react';

import { Cases, Heading } from '../../../components';



const CaseSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Case Studies'} subTitle={'Success Stories'} />

      {/* Case Studies Component */}
      <Cases />

    </section>

  );
}

export default CaseSection;